

document.querySelectorAll('a[href="#headerForm"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        const target = document.getElementById('headerForm');
        const headerOffset = 100;
        const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });

        history.replaceState(null, null, '#headerForm');
    });
});
